export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  name?: string;
}

export const CHEVRON_ORIENTATION_UP = "CHEVRON_ORIENTATION_UP";
export const CHEVRON_ORIENTATION_DOWN = "CHEVRON_ORIENTATION_DOWN";
export const CHEVRON_ORIENTATION_LEFT = "CHEVRON_ORIENTATION_LEFT";
export const CHEVRON_ORIENTATION_RIGHT = "CHEVRON_ORIENTATION_RIGHT";

export type ChevronOrientation =
  | typeof CHEVRON_ORIENTATION_UP
  | typeof CHEVRON_ORIENTATION_DOWN
  | typeof CHEVRON_ORIENTATION_LEFT
  | typeof CHEVRON_ORIENTATION_RIGHT;
